/**
 * Maps Searchspring listing API product shapes to Beacon 2.0 category/search payloads.
 * @see https://docs.searchspring.com/reference/category-tracking-guide
 * @see https://docs.searchspring.com/reference/search-tracking-guide
 */

export const mapListingProductToBeaconResult = (product) => {
  const uid = String(product?.uid ?? product?.id ?? '');
  if (!uid) {
    throw new Error('Listing beacon: product missing uid');
  }
  const parentId = String(product?.parentId ?? uid);
  const out = {
    type: 'product',
    parentId,
    uid,
  };
  if (product?.sku) {
    out.sku = String(product.sku);
  }
  return out;
};
